import VideoStreamBlueprintsProcessor from "./VideoStreamBlueprintsProcessor.js";
export default {
  install(molten) {
    molten.addPlugin('Molten.blueprintsProcessor', VideoStreamBlueprintsProcessor);
  }
};